import {
  getDefaultLocale,
  LOCALE,
  SUPPORTED_LOCALE
} from "@kivunova/kivufrontendcommon";

const WELCOME_AD_S3_BUCKET = process.env.REACT_APP_S3_TRANSLATION_BUCKET;

const resolveWelcomeAdLocale = (language: string): LOCALE =>
  SUPPORTED_LOCALE.includes(language as LOCALE)
    ? (language as LOCALE)
    : getDefaultLocale();

export const getWelcomeAdVideoUrl = (language: string): string => {
  const locale = resolveWelcomeAdLocale(language);
  return `${WELCOME_AD_S3_BUCKET}/images/ad-${locale}.mp4`;
};

export const getWelcomeAdVideoFallbackUrl = (): string =>
  getWelcomeAdVideoUrl(getDefaultLocale());
